<script>

export default {
  name: "Language",
  computed: {
    languageIcon() {
      let language = localStorage.getItem('lang') || process.env.VUE_APP_LANG;
      if (language === 'en-US' || language === '"en-US"') {
        language = 'en'
      } else if (language === 'zh-CN' || language === "'zh-CN'") {
        language = 'cn'
      } else if (language === 'zh-TW' || language === "'zh-TW'") {
        language = 'tw'
      }
      const icon = {
        "cn": require("@/assets/image/language/cn.png"),
        "en": require("@/assets/image/language/en.png"),
        "tw": require("@/assets/image/language/tw.png"),
        "de": require("@/assets/image/language/de.png"),
        "ja": require("@/assets/image/language/ja.png"),
        "ms": require("@/assets/image/language/ms.png"),
        "th": require("@/assets/image/language/th.png"),
        "pt": require("@/assets/image/language/pt.png"),
        "es": require("@/assets/image/language/es.png"),
        "ru": require("@/assets/image/language/ru.png"),
        "el": require("@/assets/image/language/el.png"),
        "it": require("@/assets/image/language/it.png"),
        "tr": require("@/assets/image/language/tr.png"),
        "fr": require("@/assets/image/language/fr.png"),
        "ko": require("@/assets/image/language/ko.png"),
        "ph": require("@/assets/image/language/ph.png"),
        "ar": require("@/assets/image/language/ar.png"),
        "vi": require("@/assets/image/language/vi.png"),
        "hi": require("@/assets/image/language/hi.png"),
        "id": require("@/assets/image/language/id.png"),
      };
      return language ? icon[language] : icon['en'];
    },
  },
}
</script>

<template>
  <div @click="$router.push('/Language')" class="lang-wrap">
    <img :src="languageIcon" alt="" class="lang-img"/>
  </div>
</template>

<style scoped lang="less">
.lang-wrap {
  display: flex;
  align-items: center;
  margin-right: 10px;

  .lang-img {
    height: 44px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
  }
}
</style>